import {
  ComputedFieldProps,
  DropdownOption,
  ReadOnlyField,
  unsafeLocalizedString,
} from "@dbn/omnichannel-design-system-g4p";
import { array, option, tuple } from "fp-ts";
import { constant, pipe } from "fp-ts/function";
import { Option } from "fp-ts/Option";
import { NonEmptyString } from "io-ts-types/lib/NonEmptyString";
import * as remoteData from "../../../../../../RemoteData";
import { useFormatMessage } from "../../../../../../intl";
import { useQuery } from "../../../../../../useAPI";
import { businessSectors } from "../../../../api";
import {
  dropdownOptionToValue,
  selectedDropdownOption,
} from "../../../../../../Common/selectDropdownOption";
import { DropdownField } from "../../../../../../Common/DropdownField/DropdownField";

export type Props = {
  fieldProps: ComputedFieldProps<Option<NonEmptyString>>;
  disabled?: boolean;
  readOnly?: boolean;
};

export function BusinessSectorField(props: Props) {
  const formatMessage = useFormatMessage();

  const dropdownProps = props.fieldProps;

  const options: Array<DropdownOption<NonEmptyString>> = pipe(
    useQuery(businessSectors),
    tuple.fst,
    remoteData.fold(
      () => array.empty,
      () => array.empty,
      array.map(({ name, key }) => ({
        label: unsafeLocalizedString(name),
        value: key,
      }))
    )
  );

  const onChange = (value: Option<DropdownOption<NonEmptyString>>) => {
    dropdownProps.onChange(dropdownOptionToValue(value));
  };

  return props.readOnly ? (
    <ReadOnlyField
      {...dropdownProps}
      value={pipe(
        selectedDropdownOption(dropdownProps.value, options),
        option.map(val => val.label as string),
        option.getOrElse(constant(""))
      )}
      size="small"
      label={formatMessage(
        "StandardLoan.Tradesman.CompanySection.BusinessSector.label"
      )}
    />
  ) : (
    <DropdownField
      {...dropdownProps}
      clearable={false}
      label={formatMessage(
        "StandardLoan.Tradesman.CompanySection.BusinessSector.label"
      )}
      onChange={onChange}
      options={options}
      placeholder={formatMessage(
        "StandardLoan.Tradesman.CompanySection.BusinessSector.placeholder"
      )}
      searchable
      value={selectedDropdownOption(dropdownProps.value, options)}
      disabled={props.disabled || dropdownProps.disabled}
    />
  );
}
